import { useCallback } from "react";
import { useParams } from "react-router-dom";

export const WelcomePaths = {
  Root: "welcome",
  Onboarding: "onboarding",
  InstallResource: "install-resource",
  Notifiers: "notifiers",
  Success: "success",
  ConfigureApprovers: "configure-approvers",
} as const;

/**
 * Hook for building welcome paths consistently across components
 * @returns A function that builds welcome paths with the correct format
 */
export const useWelcomePath = () => {
  const { orgSlug, cloudProvider } = useParams<{
    orgSlug: string;
    cloudProvider?: string;
  }>();

  return useCallback(
    (path?: string) => {
      let basePath = `/o/${orgSlug}/${WelcomePaths.Root}`;

      if (cloudProvider) {
        basePath = `${basePath}/${WelcomePaths.Onboarding}/${cloudProvider}`;
      }

      return path ? `${basePath}/${path}` : basePath;
    },
    [orgSlug, cloudProvider]
  );
};
